import axios from "axios";
import { logout } from "../redux/features/user";
import { toast } from "react-toastify";

const Interceptors = {
  setupInterceptors: (store) => {
    // For GET requests
    axios.interceptors.request.use(
      (req) => {
        return req;
      },
      (err) => {
        return Promise.reject(err);
      }
    );

    // For POST requests
    axios.interceptors.response.use(
      (res) => res,
      (err) => {
        const status = err?.response?.status;
        const requestUrl = err?.config?.url || "";
        const isTrialSignupRequest =
          requestUrl.includes("/auth/trial_signup/send_otp") ||
          requestUrl.includes("/auth/trial_signup/verify_otp");

        // A 401 from the sign-in and password-reset calls is their answer — wrong
        // password, dead reset link — not an expired session. Treating it as one
        // logged out and, two seconds later, hard-reloaded /login under someone
        // already typing their next attempt. The caller shows the message.
        const isAuthRequest = requestUrl.includes("/auth/");

        if (status === 401 && isAuthRequest) {
          return Promise.reject(err);
        } else if (status === 401) {
          // toast.error("Please sign in again. Your session has expired");
          store.dispatch(logout());
          setTimeout(() => {
            window.location.href = "/login";
          }, 2000);
        } else if (isTrialSignupRequest && status >= 400 && status < 500) {
          // Keep trial signup users on the same screen so form-level errors can render inline.
          return Promise.reject(err);
        } else if (status === 404) {
          window.location.href = "/404";
        } else if (status === 403 && err?.response?.data?.code === "trial_expired_soft_lock") {
          const payload = err?.response?.data || {};
          window.dispatchEvent(
            new CustomEvent("trial-soft-lock", {
              detail: {
                message: payload.message,
                demoRequestUrl: payload.demo_request_url,
              },
            })
          );
          toast.warning(payload.message || "Trial access has ended for this account.");
          return Promise.reject(err);
        } else if (status === 502) {
          return Promise.reject(err);
        } else {
          const errorMessage =
            err?.response?.data?.message ||
            err?.message ||
            "An unexpected error occurred";

          toast.error(errorMessage);
          console.error("Axios error response:", {
            status: status,
            data: err?.response?.data,
            fullError: err,
          });
        }

        return Promise.reject(err);
      }
    );
  },
};

export default Interceptors;
